<template>
  <dialog
    ref="dialogEl"
    class="interactive__dialog"
    :style="[position, { zIndex: opensToBottom ? '5' : '15' }]"
    :aria-labelledby="`dialog-content-${idPrefix}`"
    @mouseenter="$emit('pointer-enter')"
    @mouseleave="$emit('pointer-leave')">
    <a
      v-if="selectedShape.entityType !== 'ChannelNode'"
      :id="`dialog-content-${idPrefix}`"
      class="interactive__dialog-link"
      :href="(products.find(p => p.id === selectedShape.code) || {}).url">

      <!-- NEW PRODUCT -->
      <oie-base-label
        v-if="(products.find(p => p.id === selectedShape.code) || {}).newsSection"
        is-type="new"
        :text="(products.find(p => p.id === selectedShape.code) || {}).newsSection"></oie-base-label>
      <!-- PRODUCT NAME -->
      <h2 v-if="(products.find(p => p.id === selectedShape.code) || {}).name" class="product-card__name">
        <span class="product-card__url product-carousel__link">
          {{ (products.find(p => p.id === selectedShape.code) || {}).name }}
        </span>
      </h2>
      <!-- PRODUCT PRICE -->
      <oie-product-price
        :show-bracket-prices="false"
        :current-object="products.find(p => p.id === selectedShape.code)"
        :is-product="true"
        class="product-card__price"></oie-product-price>
    </a>
    <a
      v-else
      :id="`dialog-content-${idPrefix}`"
      class="interactive__dialog-link"
      :href="selectedShape.categoryUrl">
      <h2 class="product-card__name">
        <span class="product-card__url product-carousel__link">
          {{ tStatic('merchendiseCategoryLinkText') }} {{ selectedShape.categoryName }}
        </span>
      </h2>
    </a>

    <svg
      class="interactive__dialog-link-arrow"
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.80758 5.46334L0 1.09129L0.992977 0L7 5.46334L0.99691 10.9228L0.00491573 9.83146L4.80758 5.46334Z"
        fill="#006DB6" />
    </svg>
  </dialog>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    selectedShape: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      default: () => []
    },
    idPrefix: {
      type: String,
      required: true
    },
    position: {
      type: Object,
      default: () => ({ top: '0px', left: '0px' })
    },
    opensToBottom: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pointer-enter', 'pointer-leave'],
  setup () {
    const dialogEl = ref(null)

    const show = () => dialogEl.value && dialogEl.value.show()
    const close = () => dialogEl.value && dialogEl.value.close()

    return { dialogEl, show, close }
  }
})
</script>

<style lang="scss">
.interactive__dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3125rem;
  background-color: white;
  border: 1px solid #DFDFDF;
  padding: 0.625rem;
  padding-right: 1.5rem;
  max-width: 24rem;
  visibility: hidden;
  z-index: 50 !important;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 700;
  outline: none !important;
  &:focus:not(:focus-visible) { outline: none !important }
}

.interactive__dialog .label--new {
  margin-bottom: 0.25rem;
}

.interactive__dialog[open] {
  visibility: visible;
}

.interactive__dialog-close {
  position: absolute;
  top: 5px;
  right: 5px;
}

.interactive__dialog-link {
  outline: none;
  text-decoration: none;
  color: color(text);
  &:focus:not(:focus-visible) { outline: none !important }
}

.interactive__dialog-link-arrow {
  position: absolute;
  bottom: 20px;
  transform: translateY(50%);
  right: 7px;
}
</style>
